import * as THREE from 'three'
import EventEmitter from 'events'

export class Time extends EventEmitter {
  constructor() {
    super()

    this.clock = new THREE.Clock()
    this.previousTime = 0
    this.delta = 0
    this.elapsedTime = 0
    this.rafId = null

    this.rafId = window.requestAnimationFrame(() => this.tick())
  }

  tick() {
    this.elapsedTime = this.clock.getElapsedTime()
    this.delta = this.elapsedTime - this.previousTime
    this.previousTime = this.elapsedTime

    this.emit('tick')

    this.rafId = window.requestAnimationFrame(() => this.tick())
  }

  destroy() {
    if (this.rafId !== null) {
      window.cancelAnimationFrame(this.rafId)
      this.rafId = null
    }
  }
}
